import { render, staticRenderFns } from "./SVC40000.vue?vue&type=template&id=1c529f9c&"
import script from "./SVC40000.vue?vue&type=script&lang=js&"
export * from "./SVC40000.vue?vue&type=script&lang=js&"
import style0 from "./SVC40000.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports